import styled from '@emotion/styled'

const ScreenContainer = styled.div`
  height: 100dvh;
  display: flex;
  flex-direction: column;
`

export default ScreenContainer
